var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.556,
    height: 62.557,
    viewBox: "0 0 62.556 62.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "night-mode",
    d: "M62.936,40.028a2.085,2.085,0,0,0-2.172-.488A27.983,27.983,0,0,1,25.009,3.784a2.085,2.085,0,0,0-2.66-2.664A31.717,31.717,0,0,0,10.41,8.672,32.15,32.15,0,1,0,55.877,54.14,31.715,31.715,0,0,0,63.43,42.2a2.085,2.085,0,0,0-.494-2.17ZM52.929,51.192A27.981,27.981,0,1,1,19.868,6.763a32.342,32.342,0,0,0,8.756,29.155,32.334,32.334,0,0,0,29.155,8.756,27.845,27.845,0,0,1-4.849,6.519Z",
    transform: "translate(-0.993 -1)",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/Night.6b4a6952df2aba5854e1b81dc3b0497b.svg";
export { ForwardRef as ReactComponent };